import { TimePair, WeeklyScheduleInputEntry } from './types';

export const DEFAULT_TIME_PAIR: TimePair = {
  endMinutes: 24 * 60,
  startMinutes: 0,
};

export const EMPTY_WEEKLY_SCHEDULE_INPUT_ENTRY: WeeklyScheduleInputEntry = {
  daysOfWeek: [],
  timePairs: [DEFAULT_TIME_PAIR],
  open24Hours: false,
};
